import type { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { ErrorBoundary } from "@vixio/ui";
import { reportError } from "@vixio/errors/browser";

/**
 * Falha numa tela não derruba o painel: o menu continua, a tela mostra "Tentar de novo" e o erro vai ao GlitchTip.
 * Trocar de rota limpa o erro.
 */
export function ScreenBoundary({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  return (
    <ErrorBoundary resetKey={pathname} onError={(error) => reportError(error, pathname)}>
      {children}
    </ErrorBoundary>
  );
}
